import { Component, OnInit } from '@angular/core';
import { Bookings } from 'src/app/shared/models/bookings.model';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import * as moment from 'moment';
import { BookingsService } from '../bookings.service';
@Component({
  selector: 'app-bookings-log',
  templateUrl: './bookings-log.component.html',
  styleUrls: ['./bookings-log.component.css']
})
export class BookingsLogComponent implements OnInit {
  viewFlag = false;
  viewAdminApprovalFlag = false;

  booking = new Bookings();
  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (this.currentFilterObject.paymentStatus) {
        return row.paymentStatus
          .toLowerCase()
          .includes(this.currentFilterObject.paymentStatus.toLowerCase());
      }
      return true;
    })
      .filter(row => {
        if (
          this.currentFilterObject.bookingDate &&
          this.currentFilterObject.bookingDate.startDate &&
          this.currentFilterObject.bookingDate.endDate
        ) {
          return moment(row.bookingDate).isBetween(
            // @ts-ignore
            this.currentFilterObject.bookingDate.startDate._i,
            // @ts-ignore
            this.currentFilterObject.bookingDate.endDate._i
          );
        } else {
          return true;
        }
      })
      .filter(row => {
        if (this.currentFilterObject.experienceType) {
          return row.experienceType
            .toLowerCase()
            .includes(this.currentFilterObject.experienceType.toLowerCase());
        }
        return true;
      })
      .filter(row => {
        if (this.currentFilterObject.amount) {
          return row.amount.includes(this.currentFilterObject.amount);
        }
        return true;
      })
      .filter(row => {
        if (this.currentFilterObject.price) {
          return row.price.includes(this.currentFilterObject.price);
        }
        return true;
      });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }
  private Data = [] as Array<TableViewItem>;

  tableColumns = [
    'experienceName',
    'travelerName',
    'localName',
    'no_ofTraveler',
    'bookingDate',
    'paymentStatus',
    'experienceType',
    'amount',
    'price'
  ];

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'bookingDate',
      fieldDisplayName: 'Booking Date ',
      fieldType: 'daterange'
    },
    {
      fieldName: 'experienceType',
      fieldDisplayName: 'Experience Type ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Not Assigned' },
        { value: 'WEEKLY', display: 'Weekly' },
        { value: 'SEASONAL', display: 'Seasonal' }
      ]
    },
    {
      fieldName: 'paymentStatus',
      fieldDisplayName: 'Payment Status ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: 'APPROVED', display: 'Approved' },
        { value: 'PENDING', display: 'Pending' },
        { value: 'DECLINED', display: 'Declined' }
      ]
    },
    {
      fieldName: 'amount',
      fieldDisplayName: 'Amount ',
      fieldType: 'text'
    },
    {
      fieldName: 'price',
      fieldDisplayName: 'Price ',
      fieldType: 'text'
    }
  ];

  constructor(private bookingApi: BookingsService) {}

  currentFilterObject = {} as FilterModel;

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })

    this.fetchAllBookings();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllBookings() {
    this.bookingApi.getAllBookings().subscribe(response => {
      // console.log(response)
      this.data = response.data.bookings.map(r => {
        this.booking = r;
        // console.log(r)
        if (r.city == null) {
          r.city = '-';
          r.country = '-';
        }
        let rating = '';
        if (r.rating == null) {
          rating = '-';
        } else {
          rating = r.rating;
        }
        const noOfTravler = r.numberOfAdults + r.numberOfChildren;

        let expType = '';
        if (r.experienceTypes == null) {
          expType = '-';
        }
        return {
          experienceName: r.Experiences[0].name,
          travelerName: r.Traveler.firstName + ' ' + r.Traveler.lastName,
          localName: r.Local.firstName + ' ' + r.Local.lastName,
          no_ofTraveler: String(noOfTravler),
          bookingDate: r.createdAt,
          paymentStatus: r.paymentStatus,
          experienceType: expType,
          amount: String(r.paymentAmount),
          price: String(r.Experiences[0].price)
        } as TableViewItem;
      });
    });
  }
}

interface TableViewItem {
  experienceName?: string;
  travelerName?: string;
  localName?: string;
  no_ofTraveler?: string;
  bookingDate?: string;
  paymentStatus?: string;
  experienceType?: string;
  amount?: string;
  price?: string;
}
interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
interface FilterModel {
  bookingDate?: DateRangeModel;
  experienceType?: string;
  paymentStatus?: string;
  amount?: string;
  price?: string;
}
